export default "__VITE_ASSET__DSGnndOU__"